import { EXPANDED_MEMBERS, EXPANDED_POSTS, EXPANDED_LEADERBOARD } from "../../mockData";
import { CONTENT, notShelved } from "../constants/navigation";

export const PROMPTS = ["Share a drill you ran this week: what was the constraint?","What coaching problem are you working through right now?","Drop a win from this week that most people would overlook.","How do you handle a player who won't commit under pressure?","Where are you coaching and what's different about the game there?","What resource has shaped your coaching most this year?"];
export const HINTS = ["Search drills, coaches, insights...","Try \"finishing under contact\"...","Search by coach name...","Find practice plans...","Try \"ball handling games\"..."];
// Static MEMBERS registry — kept as fallback. Real member data now flows through
// communityApi.fetchMembers() (Supabase-backed) passed into components via state.
export const MEMBERS = {
  ...EXPANDED_MEMBERS,
};
// Gather all content items across all sections for dashboard use
export const ALL_CONTENT_ITEMS = Object.entries(CONTENT).flatMap(([sid,sec])=>(sec.items||[]).filter(notShelved).map(i=>({...i,sectionId:sid})));

export const POSTS_DATA = EXPANDED_POSTS;
export const TRENDING_POSTS = [...POSTS_DATA].sort((a,b)=>(b.likes+b.replies.length*2)-(a.likes+a.replies.length*2));
export const LEADERBOARD = EXPANDED_LEADERBOARD;
export const ALL_TAGS_COMM = ["All","Drill Drop","Win","Question","Insight","Q&A"];
